import Svg from '@material-symbols/svg-400/outlined/close-fill.svg'
import { type SvgIconProps } from '@mui/material'
import { MaterialSymbol } from './MaterialSymbol'

export function CloseIcon(props: SvgIconProps) {
  return <MaterialSymbol icon={Svg} {...props} />
}
